import { InjectionToken } from "@angular/core";


export const MODULE_VERSION = new InjectionToken<string>("ModuleVersion");
